import { Injectable } from '@angular/core';

@Injectable()
export class RefactorService {


  constructor() { }

  /**
   * This service is currently only used for development purposes - not for production implementation
   */
  // Do not delete. This is for the renaming of keys. It recursively searches through an object replacing all oldKey keys with newKey keys.
  replaceKey(obj: any, oldKey: any, newKey: any): any {
    if (Array.isArray(obj)) {
      return obj.map(arrObj => this.replaceKey(arrObj, oldKey, newKey));
    } else {
      let value;

      for (const key in obj) {
        if (key) {
          // Get the value
          value = obj[key];

          // If this is an object, recurse
          if (typeof value === 'object' || Array.isArray(value)) {
            value = this.replaceKey(value, oldKey, newKey);
          }
          if (key === oldKey) {
            obj[newKey] = value;
            delete obj[oldKey];
          }
        }
      }
      return obj;
    }
  }

}
